export default "__VITE_ASSET__Dfju4mld__"